module.exports = __webpack_public_path__ + "img/otherPortfolio.05e10ea1.svg";